export default __webpack_public_path__ + "static/media/footer-img.0f7899eb.jpeg";